import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { PublicBidStatus } from "../../../autogen/bff-api";
import { deriveBidOutcome, type BidOutcome } from "./bidOutcome";

interface Props {
  status: PublicBidStatus;
  // True once the event has reached an award decision. A still-SUBMITTED bid then
  // reads as "not selected" rather than "submitted".
  awarded?: boolean;
  size?: "sm" | "md" | "lg";
}

const meta: Record<BidOutcome, { color: string; labelKey: string }> = {
  draft: { color: "gray", labelKey: "Draft" },
  submitted: { color: "green", labelKey: "Submitted" },
  awarded: { color: "teal", labelKey: "Awarded" },
  notSelected: { color: "purple", labelKey: "Not selected" },
  rejected: { color: "red", labelKey: "Rejected" },
};

export const PublicBidStatusTag = ({
  status,
  awarded = false,
  size = "sm",
}: Props) => {
  const { t } = useTranslation();
  const { color, labelKey } = meta[deriveBidOutcome(status, awarded)];
  return (
    <Tag colorScheme={color} size={size} borderRadius="full">
      {t(labelKey)}
    </Tag>
  );
};
